import React from "react";
import { H2 } from "../../../designSystem/typography/Heading";
import { HtmlEditor } from "../../../designSystem/inputs/HtmlEditor";
import { Checkbox } from "../../../designSystem/inputs/Checkbox";
import { HtmlEditorWithSave } from "../../../designSystem/inputs/HtmlEditorWithSave";
import { HtmlEditorViewer } from "../../../designSystem/inputs/HtmlEditorViewer";
import { HtmlEditorWithAutoSave } from "../../../designSystem/inputs/HtmlEditorWithAutoSave";

export const HtmlEditorOverview = (): JSX.Element => 
{
    const [editorContent, setEditorContent] = React.useState('abcde');
    const [debugPanel, setDebugPanel] = React.useState(false);
    const [readonly, setReadonly] = React.useState(false);
    const [inErrorState, setInErrorState] = React.useState(false);

    return (
        <>
            <Section>
                <H2>HtmlEditorWithSave</H2>
                <HtmlEditorViewer content={editorContent} />
            </Section>

            <Section>
                <Checkbox text="debugPanel" value="debugPnl" checked={debugPanel} onChange={(_, chk) => setDebugPanel(chk)} />
                <Checkbox text="readonly" value="readonly" checked={readonly} onChange={(_, chk) => setReadonly(chk)} />
                <Checkbox text="inErrorState" value="inErrorState" checked={inErrorState} onChange={(_, chk) => setInErrorState(chk)} />
            </Section>

            <Section>
                <H2>Basic HtmlEditor</H2>
                <HtmlEditor debugPanel={debugPanel}
                    id="basicHtmlEditor"
                    value={editorContent}
                    onChange={(content) => setEditorContent(content)}
                    inErrorState={inErrorState}
                    placeholder="Her er en placeholder"
                    readonly={readonly} />
            </Section>


            <Section>
                <H2>HtmlEditorWithSave</H2>
                <HtmlEditorWithSave
                    id="htmlEditorWithSave"
                    debugPanel={debugPanel}
                    value={editorContent}
                    onSave={(content) => setEditorContent(content)}
                    readonly={readonly}
                />
            </Section>

            <Section>
                <H2>HtmlEditorWithAutoSave where save succeeds</H2>
                <HtmlEditorWithAutoSave
                    id="htmlEditorWithAutoSave"
                    debugPanel={debugPanel}
                    value={editorContent}
                    onSave={async (content) => {
                        setEditorContent(content);
                        return true;
                    }}
                    readonly={readonly}
                />
            </Section>

            <Section>
                <H2>HtmlEditorWithAutoSave where save fails</H2>
                <HtmlEditorWithAutoSave
                    id="htmlEditorWithAutoSave"
                    debugPanel={debugPanel}
                    value={editorContent}
                    onSave={async () => {
                        return false;
                    }}
                    errorMessage="This one also has an errorMessage"
                    readonly={readonly}
                />
            </Section>

        </>
    );
};

function Section (props: { children: React.ReactNode; })
{
    return (
        <div style={{ marginBottom: '20px' }}>
            {props.children}
        </div>
    );
}
